export const LIST_QUERY_KEY = ['projects'];
